import { registerRoute, setNotFound, start } from './router.js';
import { onChange as onAuthChange } from './auth.js';
import * as home from './pages/home.js';
import * as login from './pages/login.js';
import * as tracks from './pages/tracks.js';
import * as race from './pages/race.js';
import * as editor from './pages/editor.js';
import * as roster from './pages/roster.js';
import * as raceSetup from './pages/race-setup.js';
import * as play from './pages/play.js';

registerRoute('#/', home.render);
registerRoute('#/play', play.render);
registerRoute('#/login', login.render);
registerRoute('#/tracks', tracks.render);
registerRoute('#/race', race.render);
registerRoute('#/race-setup', raceSetup.render);
registerRoute('#/edit', editor.render);
registerRoute('#/roster', roster.render);
setNotFound((mountEl) => {
  mountEl.innerHTML = '<section class="page"><h1>Not found</h1><p><a href="#/">Back home</a></p></section>';
});

const navEl = document.getElementById('nav');
function renderNav() {
  // Topbar nav mirrors .home-nav on the marketing/hub pages so the
  // editor / roster / race header reads the same. The user chip is
  // omitted on purpose — a real sign-out / account menu lands when
  // Supabase auth is wired up.
  navEl.innerHTML = `
    <a href="#/play">Pit Lane</a>
    <a href="#/tracks">Tracks</a>
    <a href="#/roster">Roster</a>
  `;
}
onAuthChange(renderNav);
renderNav();

start(document.getElementById('app'));
